@if (isLink(item) && !isFunction(item.route)) {
  <a
    [fragment]="item.fragment"
    [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
    [routerLink]="item.route"
    class="ratenow-sidenav-item"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)"
    routerLinkActive="ratenow-sidenav-item--active"
    >
    <mat-icon [svgIcon]="item.icon" class="ratenow-sidenav-item__icon"></mat-icon>
    <span class="ratenow-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="ratenow-sidenav-item__badge">{{ item.badge.value }}</span>
    }
  </a>
}

@if (isLink(item) && isFunction(item.route)) {
  <div
    (click)="item.route()"
    class="ratenow-sidenav-item"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)"
    routerLinkActive="ratenow-sidenav-item--active"
    >
    <mat-icon [svgIcon]="item.icon" class="ratenow-sidenav-item__icon"></mat-icon>
    <span class="ratenow-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="ratenow-sidenav-item__badge">{{ item.badge.value }}</span>
    }
  </div>
}

@if (isDropdown(item)) {
  <div
    (click)="onClickDropdown(item); $event.stopPropagation()"
    [class.ratenow-sidenav-item--active]="item.isOpen || isActive"
    [class.ratenow-sidenav-item--open]="item.isOpen"
    class="ratenow-sidenav-item"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)"
    >
    @if (item.icon) {
      <mat-icon [svgIcon]="item.icon" class="ratenow-sidenav-item__icon"></mat-icon>
    }
    <span class="ratenow-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="ratenow-sidenav-item__badge">{{ item.badge.value }}</span>
    }
    <mat-icon
      (click)="toggleOpen(); $event.stopPropagation()"
      class="ratenow-sidenav-item__dropdown-icon"
      svgIcon="mat:keyboard_arrow_right"
    ></mat-icon>
  </div>
  <div [@dropdown]="item.isOpen" class="ratenow-sidenav-item__dropdown">
    @for (subItem of item.children; track subItem) {
      <nx-ratenow-ui-sidenav-item
        [item]="subItem"
        [level]="level + 1"
        [isCollapsed]="isCollapsed"
      ></nx-ratenow-ui-sidenav-item>
    }
  </div>
}

@if (isSubheading(item)) {
  <div class="ratenow-sidenav-subheading">{{ item.label | translate }}</div>
  @for (subItem of item.children; track subItem) {
    <nx-ratenow-ui-sidenav-item
      [item]="subItem"
      [level]="0"
      [isCollapsed]="isCollapsed"
    ></nx-ratenow-ui-sidenav-item>
  }
}
